import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Student from './Student';
import StudentsTable from './StudentsTable';
import Layout from '../../components/Layout';
import RoutingPaths from '../RoutingPath';

const Students = () => (
  <Layout>
    <Switch>
      <Route
        path={RoutingPaths.Students}
        component={StudentsTable}
        exact
      />
      <Route
        path={RoutingPaths.Student}
        component={Student}
        exact
      />
    </Switch>
  </Layout>
);

export default React.memo(Students);
